export enum FetchableResourceStatus {
  NotFound = 'NotFound',
  Loading = 'Loading',
  Loaded = 'Loaded',
  Forbidden = 'Forbidden',
  NextPageRequested = 'NextPageRequested',
  Requested = 'Requested',
}

export type FetchableResource<T> = {
  status: FetchableResourceStatus;
  value?: T;
};
